import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { ROUTES, MANAGE_PAYROLL_ROUTES, ApplicationRoute } from "../utils";
import {
  CreateOrGenerate,
  UploadFile,
  CreatePayrollListing,
  GenerateOutput,
  ViewOutput,
  BasicInformation,
  FileSpecifications,
  MapandTransform,
  Verifymapping,
} from "../layouts";

const menu = "payroll",
  flow = "add";
export const ManagePayrollRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD}/:payrollId?`,
          `${MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD}/:flow(edit)/:payrollId?`,
        ]}
        component={UploadFile}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_PAYROLL_ROUTES.CREATE_OR_GENERATE}/:payrollId?`,
          `${MANAGE_PAYROLL_ROUTES.CREATE_OR_GENERATE}/:flow(edit)/:payrollId?`,
        ]}
        component={CreateOrGenerate}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_PAYROLL_ROUTES.GENERATE_OUTPUT}/:payrollId?`,
          `${MANAGE_PAYROLL_ROUTES.GENERATE_OUTPUT}/:flow(edit)/:payrollId?`,
        ]}
        component={GenerateOutput}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_PAYROLL_ROUTES.VIEW_OUTPUT}/:payrollId?`,
          `${MANAGE_PAYROLL_ROUTES.VIEW_OUTPUT}/:flow(edit)/:payrollId?`,
        ]}
        component={ViewOutput}
      />

      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_PAYROLL_ROUTES.CREATE_PAYROLL_LISTING}/:payrollId?`,
          `${MANAGE_PAYROLL_ROUTES.CREATE_PAYROLL_LISTING}/:flow(edit)/:payrollId?`,
        ]}
        component={CreatePayrollListing}
      />

      {/* TemporaryMapping */}
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_PAYROLL_ROUTES.BASIC_INFORMATION}/:profileId?`,
          `${MANAGE_PAYROLL_ROUTES.BASIC_INFORMATION}/:flow(add|edit|save)/:profileId?`,
        ]}
        component={BasicInformation}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_PAYROLL_ROUTES.FIXED_LENGTH}/:flow(add|edit|save)/:profileId?`,
          `${MANAGE_PAYROLL_ROUTES.FIXED_LENGTH}/:profileId?`,
        ]}
        component={FileSpecifications}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_PAYROLL_ROUTES.MAP_AND_TRANSFORM}/:profileId?`,
          `${MANAGE_PAYROLL_ROUTES.MAP_AND_TRANSFORM}/:flow(add|edit|save)/:profileId?`,
        ]}
        component={MapandTransform}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_PAYROLL_ROUTES.VERIFY_MAP}/:profileId?`,
          `${MANAGE_PAYROLL_ROUTES.VERIFY_MAP}/:flow(add|edit|save)/:profileId?`,
        ]}
        component={Verifymapping}
      />

      <Redirect exact from={ROUTES.MANAGE_PAYROLL} to={ROUTES.MANAGE_PAYROLL} />
      <Redirect to={ROUTES.HOME} />
    </Switch>
  );
};
